export function toTitleCase(input: string) {
  if (!input) return ""; // Handle null/undefined input
  return input
    .toLowerCase() // Convert the entire string to lower case
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    .join(" "); // Join the words back into a string
}

// Extract first letters of each word for initials
export function getInitials(name: string): string {
  return name
    .split(/\s+/) // split on whitespace
    .map((word) => word[0]?.toUpperCase() || "")
    .join("");
}

export const formatPhoneNumber = (phoneNumber: string): string => {
  // Trim leading/trailing whitespace
  const cleaned = phoneNumber.trim().replace(/\D/g, '');

  // Check for a 10-digit number
  if (cleaned.length === 10) {
      // Format as (XXX) XXX-XXXX
      return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
  }

  // Check for an 11-digit number starting with '1'
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
      // Format as +1 (XXX) XXX-XXXX
      return `+1 (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7, 11)}`;
  }

  // Return the original string if it doesn't match a valid format
  return phoneNumber;
};